import React from 'react';
import fr from 'facet-rest';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box/Box';
import MeetingInformationButtonPicker from 'Views/Dashboard/MeetingInformationButtonPicker';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';
import { useDashboardContext } from 'Views/Dashboard/DashboardContext';
import Avatar from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Avatar';

const styles = (theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    padding: theme.spacing(2),
    gap: `${theme.spacing(1)}px`,
    backgroundColor: theme.palette.facet.lightGray,
  },
  plannerAvatar: {
    width: theme.spacing(7),
    height: theme.spacing(7),
    marginBottom: theme.spacing(1.5),
  },
});

const NewClientPostScenarioOverviewCard = ({
  className,
  classes,
  ...rest
}) => {
  const { clientDashboardResource } = useDashboardContext();
  const plannerName = clientDashboardResource?.attr('leadPlannerName');
  return (
    <Box
      className={classNames(classes.root, className)}
      {...rest}
    >
      <Avatar
        className={classes.plannerAvatar}
        alt={plannerName}
        src={clientDashboardResource?.relationship(fr.relationships.profileImage.name)?.link('self').url()}
      >
        {plannerName.charAt(0)}
      </Avatar>
      <Typography
        color="black"
        variant={'h6'}
      >
        {`Schedule your next meeting with ${plannerName}`}
      </Typography>
      <div>
        <MeetingInformationButtonPicker label={'Schedule Meeting'} />
      </div>
    </Box>
  );
};

NewClientPostScenarioOverviewCard.defaultProps = {
  className: '',
};

NewClientPostScenarioOverviewCard.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(NewClientPostScenarioOverviewCard);
